// Prototyp-Daten. Die Nutzer-KPIs, Trades, Aktivitäten und Broker sind absichtlich leer,
// damit du die App mit echten eigenen Werten aufbaust. Nur die statische Wizard-Struktur
// bleibt hier — sie ist reine UI-Konfiguration.

export const user = {
  name: "",
  handle: "",
  focus: "",
};

export const kpis = [
  {
    id: "tages-pl",
    label: "Tages-P/L",
    value: "0,00 €",
    delta: "noch keine Trades",
    hint: "Finanzielles Ergebnis heute",
    tone: "muted",
    testid: "kpi-daily-pl",
  },
  {
    id: "trefferquote",
    label: "Trefferquote",
    value: "—",
    delta: "noch keine Daten",
    hint: "Anteil erfolgreicher Trades",
    tone: "muted",
    testid: "kpi-hitrate",
  },
  {
    id: "profit-factor",
    label: "Profit Factor",
    value: "—",
    delta: "noch keine Daten",
    hint: "Bruttogewinne / Bruttoverluste",
    tone: "muted",
    testid: "kpi-profit-factor",
  },
  {
    id: "expectancy",
    label: "Expectancy",
    value: "—",
    delta: "noch keine Daten",
    hint: "Erwartetes Ergebnis je Trade",
    tone: "muted",
    testid: "kpi-expectancy",
  },
];

export const developmentSeries = [];
export const activities = [];
export const coachHints = [];
export const strategies = [];
export const trades = [];
export const brokerAccounts = [];
export const taxRows = [];

export const wizardSteps = [
  { key: "allgemein", label: "Allgemein" },
  { key: "entry-exit", label: "Entry & Exit" },
  { key: "risiko", label: "Risiko" },
  { key: "strategie", label: "Strategie" },
  { key: "journal", label: "Journal" },
  { key: "anhaenge", label: "Anhänge" },
  { key: "ki", label: "KI-Analyse" },
  { key: "pruefen", label: "Prüfen und speichern" },
];
